import {
	Backdrop,
	createStyles,
	Fade,
	makeStyles,
	Modal,
	Theme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import FalhaPagamento from "../../../assets/kinologyIcons/svg/falha_pagamento.svg";
import { FinancialActions } from "../../../store/ducks/financial";
import { AppActions } from "../../../store/ducks/app";
import { DashBoardActions } from "../../../store/ducks/dashboard";
import {ReactComponent as Close} from "../../../assets/kinologyIcons/svg/close.svg";
import { TextsProps } from "../../../database/txt.interface";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		modal: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		paper: {
			backgroundColor: theme.palette.background.paper,
			border: "0",
			boxShadow: theme.shadows[5],
		},
	})
);

interface FaturaPendenteState {
	titulo: string;
	subtitulo: string;
	isVisible: boolean;
}

const WHATSAPP_NUMBER = "556133479291";
const INADIMPLENCIA_LIMITES = {
	ALERTA_INICIAL: 2,
	ALERTA_INTERMEDIARIO: 8,
	ALERTA_FINAL: 30,
};

const ModalFaturaPendente: React.FC = () => {
	const dispatch = useDispatch();
	const classes = useStyles();

	const [state, setState] = useState<FaturaPendenteState>({
		titulo: "",
		subtitulo: "",
		isVisible: false,
	});

	const modal_pagamento_nao_identificado = useSelector(
		(state: any) => state.financial.modal_fatura_pendente
	);

	const servico_bloqueado = useSelector(
		(state: any) => state.configs?.config_servicos?.SERVICO_BLOQUEADO
	);

	const servico_inadimplencia = useSelector(
		(state: any) => state.configs.config_inadimplencia
	);
	const inadimplencia_motivo = useSelector(
		(state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO
	) as string;

	const modalpaymentProcess = useSelector(
		(state: any) => state.financial.modal_pagamento_processado
	);
	const current_language:TextsProps = useSelector(
		(state: any) => state.configs.current_language
	);
		
		const RenderSubtitle:any = {
			fatura_pendente:<>
												<SubtitleModal bold={false} >
													{current_language?.fatura_atrasada} 
												</SubtitleModal> 
												<br />
												<SubtitleModal bold>{current_language?.efetuar_pagamento}</SubtitleModal>
											</>,
			negativacao_serasa:<>
													<SubtitleModal bold={false}>
														{current_language?.negativacao_pendencia}
													</SubtitleModal>
													<br />
													<SubtitleModal  bold={false}>{current_language?.voce_pode}<SubtitleModal bold>{current_language?.encontrar_solucao}</SubtitleModal>{current_language?.encontrar_solucao}</SubtitleModal>
												</>,
			efetue_pagamento: <>
													<SubtitleModal bold={false}>
														{current_language?.debito_nome}
													</SubtitleModal>
													<br />
													<SubtitleModal bold >{current_language?.efetuar_pagamento_2} <SubtitleModal  bold={false}>{current_language?.contato_solucao}</SubtitleModal> </SubtitleModal>
												</>
		}
	const calcularDiasInadimplencia = (): number => {
		if (!servico_inadimplencia?.INADIMPLENCIA_DATA) return 0;
		
		const dataAtual = new Date();
		const dataInadimplencia = new Date(servico_inadimplencia.INADIMPLENCIA_DATA);
		const diferencaEmMilissegundos = dataInadimplencia.getTime() - dataAtual.getTime();
		return Math.abs(Math.ceil(diferencaEmMilissegundos / (1000 * 60 * 60 * 24)));
		
	};
	let typeClientLocalStorage = localStorage.getItem('TypeClientFinancial')
	
	const atualizarMensagemInadimplencia = (dias: number) => {
		const lastShown = localStorage.getItem("lastShownDate");
		
		const today = new Date().toISOString().split("T")[0];
		
		if(dias >= 8){
			dispatch(AppActions.set_block_side_menu(true))
		}

		if (
			dias >= INADIMPLENCIA_LIMITES.ALERTA_INICIAL 
			&& dias < INADIMPLENCIA_LIMITES.ALERTA_INTERMEDIARIO
			&& lastShown !== today
			&& !modalpaymentProcess 
		) {
			// difDay >= 2 && difDay < 8 && ultima visualização != hoje
			setState(prev => ({
				...prev,
				isVisible: true,
				titulo: current_language?.menu_lateral_fatura_pendente,
				subtitulo: 'fatura_pendente'
			}));
			localStorage.setItem("lastShownDate", today);
			dispatch(FinancialActions.set_modal_fatura_pendente(true));
		} 
		if (
			dias >= INADIMPLENCIA_LIMITES.ALERTA_INTERMEDIARIO 
			&& dias < INADIMPLENCIA_LIMITES.ALERTA_FINAL
			&& lastShown !== today
			&& !modalpaymentProcess 
		) {
			// difDay >= 8 && difDay < 30 && ultima visualização != hoje
			setState(prev => ({
				...prev,
				isVisible: true,
				titulo: current_language?.evitar_negativacao_serasa,
				subtitulo: 'negativacao_serasa'
			}));
			dispatch(FinancialActions.set_modal_fatura_pendente(true));
			localStorage.setItem("lastShownDate", today);
		} 
		if( 
			dias >= INADIMPLENCIA_LIMITES.ALERTA_INTERMEDIARIO  
			&& dias < INADIMPLENCIA_LIMITES.ALERTA_FINAL 
			&& lastShown === today
			&& typeClientLocalStorage == 'bank_slip_pix'
			&& !modalpaymentProcess 
		){
				// difDay >= 8 && difDay < 30 && ultima visualização === hoje
			dispatch(dispatch(FinancialActions.set_modal_escolha_pagamento(true)))
			localStorage.setItem("lastShownDate", today);
		}	
		if (
			dias >= INADIMPLENCIA_LIMITES.ALERTA_FINAL
			&& lastShown !== today
			&& !modalpaymentProcess 
		) {
			setState(prev => ({
				...prev,
				isVisible: true,
				titulo: current_language?.efetuar_pagamento_2,
				subtitulo:'efetue_pagamento'
			}));
			localStorage.setItem("lastShownDate", today);
			dispatch(FinancialActions.set_modal_fatura_pendente(true));
		}
		if(
			dias >= INADIMPLENCIA_LIMITES.ALERTA_FINAL 
			&& lastShown === today 
			&& typeClientLocalStorage == 'card'
			&& !modalpaymentProcess 
		){
			//difDay >=  30 && ultima visualização == hoje
			dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo));
			localStorage.setItem("lastShownDate", today);
		}
	
		if(
			dias >= INADIMPLENCIA_LIMITES.ALERTA_FINAL 
			&& lastShown === today  
			&& typeClientLocalStorage === 'bank_slip_pix'
			&& !modalpaymentProcess 
		){
			// difDay >= 30 &&  ultima visualização == hoje &&   typeClientLocalStorage === 'bank_slip_pix' 
			dispatch(dispatch(FinancialActions.set_modal_escolha_pagamento(true)))
			localStorage.setItem("lastShownDate", today);
		}
		if( 
			dias >= INADIMPLENCIA_LIMITES.ALERTA_INTERMEDIARIO 
			&&  dias < INADIMPLENCIA_LIMITES.ALERTA_FINAL 
			&& lastShown === today 
			&& typeClientLocalStorage == 'card'
			&& !modalpaymentProcess 
		){
			//difDay >= 8 && difday < 30 && ultima visualização == hoje
			dispatch(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo));
			localStorage.setItem("lastShownDate", today);
		}
		
	};

	useEffect(() => {
		const diasInadimplencia = calcularDiasInadimplencia();
		atualizarMensagemInadimplencia(diasInadimplencia);
	}, [servico_inadimplencia]);

	const handleClose = () => {
		dispatch(FinancialActions.set_modal_fatura_pendente(false));
	};

	const handlePagarFatura = () => {
		dispatch(FinancialActions.set_modal_fatura_pendente(false));
	
		if(typeClientLocalStorage == 'bank_slip_pix'){
			dispatch(dispatch(FinancialActions.set_modal_escolha_pagamento(true)))
		}else{
			dispatch(DashBoardActions.set_current_page("adicionar_pagamento"));
		}
	};

	const handleEntrarContato = () => {
		window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
	};

	if (!state.isVisible) return null;

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={modal_pagamento_nao_identificado}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{ timeout: 500 }}
		>
			<Fade in={modal_pagamento_nao_identificado}>
				<ModalContainer>
					<ModalContent>
						<HeaderContainer onClick={handleClose}  style={{display: state.titulo === 'Fatura pendente' ? 'flex' : 'none'}}>
								<Close width={18} height={18} style={{right:15, top:20,  position: 'absolute'}}/>
						</HeaderContainer>
						<IconContainer>
							<ModalIcon src={FalhaPagamento} alt="Falha no pagamento" />
						</IconContainer>
						<Title>{state.titulo}</Title>
						{RenderSubtitle[state.subtitulo]}
						<ButtonContainer>
							<Button primary onClick={handlePagarFatura}>
								{current_language?.pagar_fatura}
							</Button>
							<Button onClick={handleEntrarContato}>
								{current_language?.entrar_em_contato}
							</Button>
						</ButtonContainer>
					</ModalContent>
				</ModalContainer>
			</Fade>
		</Modal>
	);
};

// Styled Components
const ModalContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: fixed;
	inset: 0;
	width: 100vw;
	height: 100vh;
`;
const SubtitleModal = styled.div<{bold:boolean}>`
	color: #000E4B;
	display: inline;
	font-family: 'NotoSans-Regular';
	font-weight: ${({bold})=> bold ? '700' : '400'};
`;
const ModalContent = styled.div`
	background: white;
	padding: 20px;
	position: relative;
	border-radius: 0.75rem;
	max-width: 25%;
	width: 100%;
	text-align: center;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const HeaderContainer = styled.div<{visible?: boolean}>`
	width: 100%;
	display: flex;
	justify-content: flex-end;
`;

const CloseButton = styled.button`
	background: none;
	border: none;
	font-size: 16px;
	cursor: pointer;
	padding: 8px;
	
	&:hover {
		opacity: 0.8;
	}
`;

const ButtonContainer = styled.div`
	display: flex;
	margin-top: 10px;
	justify-content: space-between;
	gap: 10px;
`;

const InfoText = styled.p`
	font-size: 14px;
	color: #333;
	margin: 1.5rem 0;
	line-height: 1.5;
`;

const IconContainer = styled.div`
	margin: 16px 0;
`;

const ModalIcon = styled.img`
	width: 4rem;
	height: 4rem;
`;

const Title = styled.h2`
	font-size: 18px;
	color: #002060;
	margin: 0 0 8px;
	font-weight: 600;
`;

interface ButtonProps {
	primary?: boolean;
}

const Button = styled.button<ButtonProps>`
	width: 100%;
	padding: 12px;
	font-size: 16px;
	font-weight: bold;
	background-color: ${({ primary }) => (primary ? "#009973" : "white")};
	color: ${({ primary }) => (primary ? "white" : "#009973")};
	border: ${({ primary }) => (primary ? "none" : "1px solid #009973")};
	border-radius: 0.75rem;
	margin-bottom: 8px;
	cursor: pointer;
	transition: all 0.2s ease-in-out;

	&:hover {
		background-color: ${({ primary }) => (primary ? "#008863" : "#f6f6f6")};
	}

	&:active {
		transform: scale(0.98);
	}
`;

export default ModalFaturaPendente;
